import { render, staticRenderFns } from "./HeadingMobile.vue?vue&type=template&id=18db7646&"
import script from "./HeadingMobile.vue?vue&type=script&lang=js&"
export * from "./HeadingMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports